import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  signal,
} from '@angular/core';
import { ITedMessage } from '@g99-product-web-ui/shared-interface-lib';
import { TenantService } from '@g99-product-web-ui/shared-service';
import {
  SendIcon,
  TedChatBubbleIcon,
} from '@g99-product-web-ui/shared-util-lib';

import { TedService } from '../../../../services/ted.service';

@Component({
  selector: 'g99-lib-ted-chat',
  templateUrl: './ted-chat.component.html',
  styleUrls: ['./ted-chat.component.scss'],
  standalone: false,
})
export class TedChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('messagesContainer')
  private readonly _messagesContainer!: ElementRef<HTMLDivElement>;

  protected readonly tedIcon = TedChatBubbleIcon;
  protected readonly sendIcon = SendIcon;

  protected readonly messages = signal<ITedMessage[]>([]);
  protected readonly isLoading = signal(false);
  protected readonly chatInput = signal('');

  private _businessId = '';
  private _shouldScrollToBottom = false;

  constructor(
    private readonly _tedService: TedService,
    private readonly _tenantService: TenantService
  ) {}

  public ngOnInit(): void {
    this._businessId = this._tenantService.getBusinessId();

    this.messages.set([
      {
        type: 'assistant',
        content:
          "Hi! I'm Ted, your data assistant. Ask me anything about your business data â€” clients, tasks, support tickets, SEO tasks, and more.",
        timestamp: new Date(),
      },
    ]);

    this._tedService.loadConfig().subscribe();
  }

  public ngAfterViewChecked(): void {
    if (this._shouldScrollToBottom) {
      this._scrollToBottom();
      this._shouldScrollToBottom = false;
    }
  }

  protected onInputChange(event: Event): void {
    this.chatInput.set((event.target as HTMLInputElement).value);
  }

  protected onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSend();
    }
  }

  protected onSend(): void {
    const text = this.chatInput().trim();
    if (!text || this.isLoading()) {
      return;
    }

    this._addMessage({ type: 'user', content: text, timestamp: new Date() });
    this.chatInput.set('');
    this.isLoading.set(true);

    if (!this._tedService.isReady) {
      this._addMessage({
        type: 'assistant',
        content: 'Still loading configuration, please try again in a moment.',
        timestamp: new Date(),
      });
      this.isLoading.set(false);
      return;
    }

    this._tedService.ask(text, this._businessId).subscribe({
      next: (answer) => {
        this._addMessage({
          type: 'assistant',
          content: answer,
          timestamp: new Date(),
        });
        this.isLoading.set(false);
      },
      error: () => {
        this._addMessage({
          type: 'assistant',
          content: 'Sorry, I had trouble fetching your data. Please try again.',
          timestamp: new Date(),
        });
        this.isLoading.set(false);
      },
    });
  }

  private _addMessage(msg: ITedMessage): void {
    this.messages.update((prev) => [...prev, msg]);
    this._shouldScrollToBottom = true;
  }

  private _scrollToBottom(): void {
    try {
      const el = this._messagesContainer?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    } catch {
      // ignore
    }
  }
}
